export default (value) => {
  return new Intl.NumberFormat('de-DE')
    .format(parseInt(value, 10) === 'NaN' ? 0 : value)
    .replace(/\D00$/, '')
}
